<template>
  <div class="component component--fullscreen" ref="component" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="containter">
      <div class="component__containter" v-if="componentVisible" v-body-scroll-lock="componentVisible">
        <div class="header">
          <div class="title" v-if="!showCell" v-on:click="showCell = true">{{ title }}</div>
          <div class="title" v-else v-on:click="showCell = false">{{ cell }}</div>
          <button class="toggle" v-on:click="toggleBarcode()"><i class="material-icons">close</i></button>
        </div>
        <div class="body">
          <vue-barcode
            class="barcode"
            :value="value"
            :format="format"
            :displayValue="false"
            :height="80"
          />
          <div class="content">
            <div class="name" v-if="name">{{ name }}</div>
            <div class="value">{{ value }}</div>
            <div class="timer" v-if="barcodeTime !== 0">{{ $t('barcode.barcodeTimer') }} {{ timeText }}</div>
          </div>
          <div class="qrcode" v-if="qrcode">
            <div class="fig">
              <div class="spinner">
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="55" viewBox="0 0 50 55">
                  <path fill="#333" fill-rule="evenodd" d="M25.8005492,39.8636304 L15.3138645,34.9747529 C14.2372409,34.4729404 13.7644989,33.1785069 14.2581379,32.0835839 L21.3565183,16.3350403 C21.8499441,15.2401174 23.1227439,14.7595571 24.1993675,15.2613696 L34.6860522,20.1502471 C35.7626758,20.6520596 36.2354178,21.9464931 35.741992,23.0414161 L28.6433984,38.7899597 C28.1499726,39.8848826 26.8771728,40.3654429 25.8005492,39.8636304"/>
                </svg>
              </div>
              <div class="base">
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="55" viewBox="0 0 50 55">
                  <path fill="#FFEA00" fill-rule="evenodd" d="M31.1660572,2.6279661 C27.3506144,0.457344633 22.6496023,0.457344633 18.8339428,2.6279661 L6.16605722,9.83391714 C2.35039773,12.0043252 0,16.0155995 0,20.3564156 L0,34.7685311 C0,39.1095606 2.35039773,43.1206215 6.16605722,45.2910295 L18.8339428,52.497194 C22.6496023,54.667602 27.3506144,54.667602 31.1660572,52.497194 L43.8339428,45.2910295 C47.6496023,43.1206215 50,39.1095606 50,34.7685311 L50,20.3564156 C50,16.0155995 47.6496023,12.0043252 43.8339428,9.83391714 L31.1660572,2.6279661 Z"/>
                </svg>
              </div>
            </div>
            <vue-qrcode
              :value="value"
              :options="{ size: 250 }"
              tag="img"
            />
          </div>
          <div class="caption" v-html="$t('barcode.desc')"></div>
          <template v-if="einvoiceEnable">
            <template v-if="einvoiceBarcode === null">
              <a class="btn-link" v-on:click="toggleCellphoneBarcode">{{ $t('index.connectEinvoice') }}</a>
            </template>
            <template v-else>
              <div class="einvoice-barcode" v-on:click="toggleCellphoneBarcode">
                {{ $t('index.Einvoice') }} {{ einvoiceBarcode }}
                <vue-barcode
                  class="barcode"
                  :value="einvoiceBarcode"
                  format="CODE39"
                  :displayValue="false"
                  :height="70"
                />
              </div>
            </template>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import VueQrcode from '@xkeshi/vue-qrcode';
import swal from 'sweetalert2';

export default {
  name: 'Barcode',
  props: {
    visable: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    name: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      required: true,
    },
    qrcode: {
      type: Boolean,
      required: false,
    },
    einvoiceEnable: {
      type: Boolean,
      default: false,
    },
    einvoiceBarcode: {
    },
    cell: {
      type: String,
    },
    barcodeTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      componentVisible: false,
      showCell: false,
      time: 0,
      timer: null,
      timerStart: false,
      timeText: '00:00',
      expired: false,
    };
  },
  watch: {
    visable(value) {
      if (this.expired) {
        if (this.$route.name !== 'Reward') {
          this.$router.replace(
            { query: { barcode: null } },
            () => { this.$router.go(0); },
          );
        } else {
          this.$router.go(0);
        }
      } else {
        this.$nextTick(() => {
          this.componentVisible = value;

          if (this.barcodeTime !== 0 && this.timerStart === false) {
            this.time = this.barcodeTime;
            this.timeText = new Date(this.time * 1000).toISOString().substring(14, 19);
          }
          if (this.timer === null && this.time !== 0) this.countdown();
        });
      }
    },
    barcodeTime(value) {
      if (value !== 0 && this.timerStart === false) {
        this.time = this.barcodeTime;
        this.timeText = new Date(this.time * 1000).toISOString().substring(14, 19);
      }
      if (this.timer === null && this.time !== 0) this.countdown();
    },
  },
  methods: {
    toggleBarcode() {
      this.$emit('toggleBarcode');
    },
    toggleCellphoneBarcode() {
      this.$emit('toggleCellphoneBarcode');
    },
    countdown() {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.timerStart = true;
          this.time -= 1;

          this.timeText = new Date(this.time * 1000).toISOString().substring(14, 19);
        } else {
          this.timerStart = false;
          this.expired = true;
          clearInterval(this.timer);

          this.$gtm.trackEvent({
            event: '條碼到期',
            label: `${this.$root.$store.state.brand.name}`,
          });

          if (this.visable === false) return;

          swal.fire({
            text: this.$i18n.t('common.barcodeTimeOut'),
            confirmButtonText: this.$i18n.t('common.refresh'),
          })
            .then(() => {
              this.$gtm.trackEvent({
                event: '條碼刷新',
                label: `${this.$root.$store.state.brand.name}`,
              });
              if (this.$route.name !== 'Reward') {
                this.$router.replace(
                  { query: { barcode: null } },
                  () => { this.$router.go(0); },
                );
              } else {
                this.$router.go(0);
              }
            });
        }
      }, 1000);
    },
  },
  mounted() {
    if ('barcode' in this.$route.query) {
      this.$router.replace({ query: { barcode: undefined } });

      this.$emit('toggleBarcode');
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  components: {
    VueBarcode,
    VueQrcode,
  },
};
</script>

<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css?family=Source+Code+Pro')

.fig
  position: absolute
  width: 50px
  height: 55px
  top: 50%
  left: 50%

  transform: translate(-50%, -50%) scale(.5)

  .spinner
    position: absolute
    top: 0
    left: 0
    z-index: 2

    animation: rotate 1.2s infinite cubic-bezier(.4, 0, .2, 1)

  .base
    position: absolute
    top: 0
    left: 0

  .text
    position: absolute
    top: 60px
    left: 0
    right: 0
    left: 0

    color: #777
    font-size: 0.75rem
    font-weight: 800
    text-align: center

@keyframes rotate
  0%
    transform: perspective(120px) rotateY(0deg)
  50%
    transform: perspective(120px) rotateY(180deg)
  100%
    transform: perspective(120px) rotateY(360deg)

.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  align-items: flex-end
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: relative
  width: 100vw
  max-height: 90%
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, .5)
  overflow: hidden
  overflow-y: auto
  z-index: 1050
  margin: 0 auto

  border-radius: 16px 16px 0 0

  background-color: white

  -webkit-overflow-scrolling: touch

  @media only screen and (min-width : 768px)
    max-width: 475px

.header
  position: sticky
  padding: 10px
  top: 0
  z-index: 1020

  background-color: white
  text-align: center

.title
  margin: 8px 0
  font-size: 1rem
  font-weight: bold
  color: #333

.toggle
  position: absolute
  top: 0
  right: 0
  bottom: 0

  border: none

  background: none

  color: #333

  -webkit-appearance: none
  cursor: pointer

  &:active
    opacity: .9

    outline: none

  .material-icons
    padding: 6px

.body
  padding: 0 24px 24px

  text-align: center

.barcode
  overflow: hidden
  width: 100%
  height: 100px

  background-color: white

  border-radius: 4px

::v-deep .vue-barcode-element
  display: block
  width: 100%
  max-width: 100%

  border-radius: 8px

  background-color: white

.content
  margin: 6px 16px 16px

.name
  color: #333

  font-size: 0.75rem
  font-weight: bold
  color: rgba(51, 51, 51, .6)

.value
  font-family: 'Source Code Pro', monospace
  font-size: 1.125rem
  color: #333

.timer
  font-size: 0.875rem
  font-weight: bold
  color: rgba(51, 51, 51, .6)

.qrcode
  position: relative
  width: 75%
  max-width: 200px
  margin: 0 auto
  overflow: hidden

  border-radius: 4px

  background-color: white

  img
    width: 100%
    height: auto

.caption
  margin-top: 16px

  font-size: 0.75rem
  font-weight: bold
  color: rgba(51, 51, 51, .6)

.caption
  margin-top: 16px

  font-size: 0.75rem
  font-weight: bold
  color: rgba(51, 51, 51, .6)

.btn-link
  margin-top: 24px
  padding: 8px 16px
  display: inline-block

  border-radius: 10px

  background: rgba(0, 0, 0, .075)

  text-align: center
  font-size: 0.75rem
  font-weight: bold
  color: #333

  cursor: pointer

  &:hover,
  &:active
    color: #333

.einvoice-barcode
  overflow: hidden
  margin-top: 24px
  padding: 8px 16px 16px

  border-radius: 10px

  background-color: #ffea00

  text-align: center
  font-size: 0.75rem
  font-weight: bold
  color: #333

  .barcode
    overflow: hidden
    width: 100%
    height: auto
    margin-top: 8px

    background-color: white

    border-radius: 4px

  ::v-deep .vue-barcode-element
    display: block
    width: 100%
    max-width: 100%

    border-radius: 8px

    background-color: white

    image-rendering: pixelated

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.containter-enter-active,
.containter-leave-active
  transition: opacity .25s cubic-bezier(0, 0, .2, 1), transform .15s cubic-bezier(0, 0, .2, 1)

.containter-enter,
.containter-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
